import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

import { StyledImageContainer, StyledItem } from './styled';

type QRCodeTypeItemProps = {
  title?: string;
  description?: string;
  Icon?: React.ComponentType;
  onClick?: () => void;
  disabled?: boolean;
};
export function QRCodeTypeItem({ title, description, Icon, onClick, disabled }: QRCodeTypeItemProps) {
  return (
    <StyledItem disabled={disabled} onClick={disabled ? undefined : onClick}>
      <StyledImageContainer>
        <Icon style={{ color: disabled ? COLORS.gray04 : COLORS.blue, width: '44px', height: '44px' }} />
      </StyledImageContainer>
      <div>
        <Text variant="t16Medium" sx={{ color: COLORS.textMain, textAlign: 'center' }}>
          {title}
        </Text>
        <Text variant="inputVerySmall" sx={{ color: COLORS.grey400, textAlign: 'center' }}>
          {description}
        </Text>
      </div>
    </StyledItem>
  );
}
